export default class Title {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
  }
}
